import baseAPI from '@/http'

const router = 'api/projeto/Eixo'

export const eixoAPI = {
  create: (eixo) => baseAPI.post(router, eixo),
  update: (eixo) => baseAPI.put(router, eixo),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router + '/get-eixo'),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
